import styled from 'styled-components';

import Icon from '~/src/common/components/Icon';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  ${media.M`
      max-width: 336px;
      flex:1;
  `}

  &:last-child {
    margin-bottom: 40px;
  }

  & > div:nth-child(2) {
    text-align: center;

    h3 {
      margin: 0;
      font-size: 15px;
      font-weight: 700;
      line-height: 24px;
    }

    p {
      margin: 0;
      font-size: 12px;
      line-height: 22px;
    }
  }
`;

export const Image = styled.img`
  width: 200px;
`;

export const Number = styled(Icon)`
  margin-bottom: 10px;
`;
